import React from "react";
import { ChevronDown } from "lucide-react";
import UseContext from "hooks/useContext";
import Tooltip from "components/tooltips/Tooltips";
import {
    TOOL_PROVIDER_COMPANY,
    TOOL_PROVIDER_TEMP_WORKER,
    normalizeToolProvider,
} from "pages/missionTemplates/utils/templateTools";

const SENTENCE_FALLBACKS = {
    [TOOL_PROVIDER_TEMP_WORKER]: { verb: "apporté par", who: "l'intérimaire" },
    [TOOL_PROVIDER_COMPANY]: { verb: "fourni par", who: "l'entreprise" },
};

/**
 * Who provides a piece of equipment, written as the end of a sentence: "apporté par
 * l'intérimaire". A click on the underlined word switches to the other provider.
 */
const ToolProviderSelect = ({ value, onChange, ariaLabel }) => {
    const { language } = UseContext();
    const provider = normalizeToolProvider(value);
    const t = (key, fallback) => language.getValue(`missionTemplate.tools.${key}`, fallback);
    const next = provider === TOOL_PROVIDER_COMPANY ? TOOL_PROVIDER_TEMP_WORKER : TOOL_PROVIDER_COMPANY;
    const sentence = SENTENCE_FALLBACKS[provider];

    return (
        <span className="text-sm text-gray-500">
            {t(`providerVerb.${provider}`, sentence.verb)}{" "}
            <Tooltip text={t(`providerSwitch.${next}`, next === TOOL_PROVIDER_COMPANY ? "Passer à « fourni par l'entreprise »" : "Passer à « apporté par l'intérimaire »")} placement="top">
                <button
                    type="button"
                    onClick={() => onChange(next)}
                    aria-label={ariaLabel}
                    className="inline-flex items-center gap-1 font-medium text-gray-900 underline decoration-gray-300 decoration-dashed underline-offset-4 hover:decoration-gray-900 focus:outline-none focus-visible:rounded focus-visible:ring-2 focus-visible:ring-yellow-500"
                >
                    {t(`providerWho.${provider}`, sentence.who)}
                    <ChevronDown size={14} aria-hidden="true" />
                </button>
            </Tooltip>
        </span>
    );
};

export default ToolProviderSelect;
